export default __webpack_public_path__ + "static/media/showcase-result.11588f46.jpg";